const NOT_AVAILABLE = "Not available";

const formatNumber = (value, fractionDigits = 0) => {
  if (value == null || Number.isNaN(Number(value))) return null;
  return Number(value).toLocaleString(undefined, {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });
};

export const formatDistance = (km) => {
  if (km == null || Number.isNaN(Number(km))) return NOT_AVAILABLE;
  const num = Number(km);
  const formatted = formatNumber(num, num % 1 === 0 ? 0 : 1);
  return `${formatted} km`;
};

export const formatFuelCost = (amount) => {
  if (amount == null || Number.isNaN(Number(amount))) return NOT_AVAILABLE;
  const formatted = formatNumber(amount, 2);
  return `RS ${formatted}`;
};

export const formatFuelRate = (price) => {
  if (price == null || Number.isNaN(Number(price))) return NOT_AVAILABLE;
  const formatted = formatNumber(price, 2);
  return `RS ${formatted} / L`;
};

export const formatVehicleAverage = (avg) => {
  if (avg == null || Number.isNaN(Number(avg))) return NOT_AVAILABLE;
  const num = Number(avg);
  const formatted = formatNumber(num, num % 1 === 0 ? 0 : 1);
  return `${formatted} km/L`;
};

export const formatOutOfBoundRadius = (meters) => {
  if (meters == null || Number.isNaN(Number(meters))) return NOT_AVAILABLE;
  const formatted = formatNumber(Number(meters), 0);
  return `${formatted} m`;
};

export const formatTaskDistance = (distance) => formatDistance(distance);

export const formatTaskFuel = (totalCost) => formatFuelCost(totalCost);
